import { useState, type FormEvent } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../../contexts/AuthContext";
import "./Auth.css";

export function LoginScreen() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [formError, setFormError] = useState<string | null>(null);
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setFormError(null);

    if (!email || !password) {
      setFormError("Fyll inn e-post og passord");
      return;
    }

    setLoading(true);
    const error = await login(email, password);
    setLoading(false);

    if (error) {
      setFormError(error);
    } else {
      navigate("/map", { replace: true });
    }
  }

  return (
    <div className="auth-page">
      <motion.div
        className="auth-card"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 280, damping: 26 }}
      >
        <div className="auth-card__header">
          <h1 className="auth-card__logo">
            Golle<span>giella</span>
          </h1>
          <p className="auth-card__subtitle">Logg inn for å fortsette</p>
        </div>

        <form className="auth-card__body" onSubmit={handleSubmit} noValidate>
          {formError && <p className="auth-form-error">⚠ {formError}</p>}

          <div className="auth-field">
            <label className="auth-label" htmlFor="login-email">E-post</label>
            <input
              id="login-email"
              className="auth-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
              placeholder="du@eksempel.no"
            />
          </div>

          <div className="auth-field">
            <label className="auth-label" htmlFor="login-password">Passord</label>
            <input
              id="login-password"
              className="auth-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            className="auth-submit"
            disabled={loading}
          >
            {loading ? "Logger inn…" : "Logg inn"}
          </button>
        </form>

        <div className="auth-footer">
          Ny bruker?{" "}
          <Link to="/register">Opprett konto</Link>
        </div>
      </motion.div>
    </div>
  );
}
